(function() {
    'use strict';
    angular
        .module('emarket.main.profile')
        .controller('ProfileEditPhoneController', ['$log', '$location', '$rootScope', '$scope', 'Auth', 'Announcer', 'StateQueue', 'Profile', function($log,
            $location,
            $rootScope,
            $scope,
            Auth,
            Announcer,
            StateQueue,
            Profile) {
            var vm = this;
            vm.loading = {
                saving: false,
                validating: false
            };
            vm.phone = {};
            // vm.selectedIndex = 1;
            vm.phoneTypes = Profile.phone.types;
            var user = Auth.getUser();
            if (user.phones.length > 0) {
                var isValid = user.phones.some(function(phone) {
                    return phone.status === 'validated';
                });
                if (isValid) {
                    StateQueue.go();
                }
            }
            if (user.phones.length === 1) {
                vm.phone.number = user.phones[0].number;
                vm.phone.type = user.phones[0].type;
            }
            var announcer = Announcer.createEmitter();
            announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR);
            var profile = Profile.$new(user._id);
            vm.addPhone = function() {
                vm.loading.saving = true;
                profile.phones = [ vm.phone ];
                vm.showCallAgain = false;
                profile
                    .$save([ 'phones' ])
                    .$asPromise()
                    .then(function() {
                        vm.loading.saving = false;
                        // Profile.sendPhoneValidation(vm.phone)
                        //     .then(function() {
                        //         vm.showCallAgain = true;
                        //     })
                        //     .catch(function() {
                        //         vm.showCallAgain = true;
                        //     });
                        // $location.search('pantalla', 'validar');
                        StateQueue.go();
                    })
                    .catch(function() {
                        vm.loading.saving = false;
                    });
            };
            var ev = $rootScope.$on('$locationChangeSuccess', function() {
                var currentIndex = $location.search().pantalla;
                if (currentIndex) {
                    vm.selectedIndex = 1;
                } else {
                    vm.selectedIndex = 0;
                }
            });

            vm.makePhoneValidation = function() {
                vm.loading.validating = true;
                Profile.validatePhone(vm.phone, vm.validationCode)
                    .then(function() {
                        vm.loading.validating = false;
                        // TODO: update user profile after validation
                        StateQueue.go();
                    })
                    .catch(function(err) {
                        vm.loading.validating = false;
                        vm.error = err.message;
                        // TODO: show an error message
                    });
            };
            if ($location.search().pantalla) {
                $location.search('pantalla', null);
            }
            $scope.$on('$destroy', function() {
                ev();
            });
        }]);
}());
